module.exports = __webpack_public_path__ + "img/videoPoster7.27b36e5f.jpg";